// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-dropdown {
  position: relative;
}
.menu-dropdown ul {
  position: absolute;
  right: 0;
  top: 20px;
  z-index: 3;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 162px;
  height: auto;
  border-radius: 4px;
  background: var(--sebrae-white);
  border: 1px solid #E0E5EB;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
}
.menu-dropdown ul li {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
}
.menu-dropdown ul .link {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/menu-dropdown/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,yBAAA;EACA,6CAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AACN;AACI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACN","sourcesContent":[".menu-dropdown {\n  position: relative;\n\n  ul {\n    position: absolute;\n    right: 0;\n    top: 20px;\n    z-index: 3;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 162px;\n    height: auto;\n    border-radius: 4px;\n    background: var(--sebrae-white);\n    border: 1px solid #E0E5EB;\n    box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.20);\n\n    li {\n      width: 100%;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      padding: 8px 12px;\n    }\n    .link {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
